import { IVoucher } from '@model';

import { EBenefitState, IBenefits, IProduct } from '../../../model';
import { getDeliveryBenefit } from '../../../utils';

/**
 * Method decides whether to render voucher
 *  - Render of free delivery voucher is conditional based on customer benefits
 *  - If customer has free delivery benefit we are not rendering free delivery voucher
 * @param voucher - Voucher to be conditionally rendered
 * @param benefits - Customer benefits
 */
export const shouldRenderVoucher = (voucher: IVoucher, benefits: IBenefits, products: IProduct[]): boolean => {
  if (products.some((product) => product.addedByCoupon === voucher.code)) {
    return false;
  }
  if (!voucher.isDeliveryVoucher) {
    return true;
  }

  const freeDeliveryBenefit = getDeliveryBenefit(benefits.loyalties);

  return freeDeliveryBenefit?.state !== EBenefitState.ACTIVE;
};
